import { ref, computed } from '@vue/composition-api'
import router from '@iez/core/router'
import data from '@iez/lib/data/'
import user from '@iez/lib/user/'
import dayjs from 'dayjs'
import waitFor from '@iez/lib/wait-for/'
import { page } from '@iez/core/'

const isLocked = ref(false)

export default async ({ supportedAssociationId }) => {
  await waitFor({
    dependencies: () => !isLocked.value
  })
  isLocked.value = true

  const configuration = data.get({
    root: `configurations`,
    isCalledFromComponent: false,
    fields: [
      `id`,
      `maxDailyViews`,
    ],
    request: {
      order_by: {
        createdAt: `desc`
      }
    },
    one: true
  })
  await waitFor(
    () => configuration.value
  )
  const maxDailyViews = computed(
    () => configuration.value?.maxDailyViews
  )

  const viewsAds = data.get({
    root: `viewsAds`,
    isCalledFromComponent: false,
    request: {
      where: {
        _and: {
          createdAt: {
            _gt: dayjs(await data.now())
              .set(`h`, 0)
              .set(`m`, 0)
              .set(`s`, 0)
              .format()
          },
          viewerId: {
            _eq: user.id
          }
        }
      }
    },
    fields: [
      `id`
    ]
  })
  await waitFor({
    dependencies: () => viewsAds.value
  })
  console.log(viewsAds.value.length, maxDailyViews.value)
  if (viewsAds.value.length < maxDailyViews.value) {
    const ad = data.get({
      root: `ads`,
      isCalledFromComponent: false,
      one: true,
      fetchPolicy: `network-only`,
      fields: [
        `id`,
      ],
      request: {
        where: {
          _and: {
            viewsCountRemaining: {
              _neq: 0
            }
          }
        },
        order_by: {
          watchedAt: 'asc'
        }
      }
    })
    await waitFor({
      dependencies: () => ad.value !== undefined
    })
    if (true && !ad.value?.id) {
      page.blockingDialog.set({
        title: `Désolé`,
        content: `Yako n'a aucune annonce à vous proposer pour le moment. Vous pouvez faire un ko-Don pour permettre à tout le monde de donner !`,
        action1: {
          label: `Go !`,
          onClick: () => {
            router.push({
              name: `AddSetup`,
              params: {
                type: `ko-don`
              }
            })
          }
        },
        action2: {
          label: `Non merci`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    } else {
      console.log(supportedAssociationId)
      router.push({
        name: `AdWatch`,
        params: {
          supportedAssociationId,
          adId: ad.value.id
        }
      })
    }
  } else {
    page.bottomSnackbar.set({
      content: `Vous avez déjà donné ${maxDailyViews.value} soutiens aujourd'hui.`
    })
  }

  isLocked.value = false
}
